import api from '../utils/api';

// User Profile service for API calls
export const profileService = {
  // Get user profile
  getProfile: async () => {
    try {
      const response = await api.get('/user/profile');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update user profile
  updateProfile: async (profileData) => {
    try {
      const response = await api.put('/user/profile', profileData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Request OTP for password update
  requestPasswordUpdateOTP: async () => {
    try {
      const response = await api.post('/user/updatepassword/otp');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update password with OTP
  updatePassword: async (passwordData) => {
    try {
      const response = await api.put('/user/updatepassword', passwordData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default profileService;